module.exports = __webpack_public_path__ + "img/mini_but_many.cover.6dd7d1f7.jpg";